import { render, staticRenderFns } from "./MhSelect.vue?vue&type=template&id=4805c516&scoped=true"
import script from "./MhSelect.vue?vue&type=script&lang=js"
export * from "./MhSelect.vue?vue&type=script&lang=js"
import style0 from "./MhSelect.vue?vue&type=style&index=0&id=4805c516&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4805c516",
  null
  
)

export default component.exports